// import { createSelector } from 'reselect';

export const getErrMsg = state => state.getIn(['previewNotes', 'errMsg']);
export const getIsGetting = state => state.getIn(['previewNotes', 'isGetting']);
export const getNotes = state => state.getIn(['previewNotes', 'notes']);